import React from 'react'
import {
  Link
} from 'react-router-dom'
import { dataAppDatabase, locale, polyglot, getLocale } from '../../../index'
import PropTypes from 'prop-types'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import { isDateInputAvailable } from '../../../resources/utilities'
import { Panel } from '../../common/Panel/Panel'

export default class PatientPicker extends React.Component {
  constructor (props) {
    super(props)
    this.getPatient = this.getPatient.bind(this)
    this.state = {
      locale: undefined,
      patientId: '',
      alert: 'hidden',
      redirectToReferrer: false
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount () {
    this.props.setPatientAges(undefined)
    this.props.setPatientId(undefined)
    this.setState({
      locale: getLocale()
    })
  }

  getPatient (patientNumber) {
    const rootRef = dataAppDatabase.ref()
    const patientRef = rootRef.child('riso').child('patientsByCountry').child(locale)
    let patient
    patientRef.on('value', snapshot => {
      snapshot.forEach((childSnap) => {
        if (childSnap.val().patientNumber.toString() === patientNumber) {
          patient = childSnap.val()
        }
      })
      if (patient) {
        this.setState({
          redirectToReferrer: true
        })
      } else {
        this.setState({
          alert: 'alert alert-danger'
        })
      }
    })
  }

  handleSubmit (event) {
    event.preventDefault()
    this.getPatient(this.state.patientId)
  }

  handleChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  render () {
    return (
      <div className='container'>
        <div className='col-xs-12 col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3 patient-number-container'>
          <PatientNumberForm alert={this.state.alert} handleChange={this.handleChange} patientId={this.state.patientId} handleSubmit={this.handleSubmit} />
        </div>
        <div className='col-xs-12 col-md-12 col-lg-10 col-lg-offset-1 patients-table no-side-padding'>
          <Panel heading={polyglot.t('patientPicker.patients')}>
            <PatientsTable locale={this.state.locale} />
          </Panel>
        </div>
      </div>
    )
  }
}

PatientPicker.propTypes = {
  setPatientAges: PropTypes.func.isRequired,
  setPatientId: PropTypes.func.isRequired
}

class PatientsTable extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      search: '',
      currentDoctorPatients: null
    }
    this.searchPatientByBirthday = this.searchPatientByBirthday.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.getPatients = this.getPatients.bind(this)
    this.getAllPatients = this.getAllPatients.bind(this)
  }

  componentWillMount () {
    this.setState({
      locale: locale
    }, this.getPatients)
  }

  searchPatientByBirthday () {
    if (this.state.search !== '') {
      let value
      if (typeof (this.state.search) === 'string') {
        value = this.state.search
      } else {
        value = (this.state.search).format('YYYY-MM-DD')
      }
      const rootRef = dataAppDatabase.ref()
      const patientRef = rootRef.child('riso').child('patientsByCountry').child(this.props.locale)
      let patients = {}
      patientRef.on('value', snapshot => {
        snapshot.forEach((childSnap) => {
          if (childSnap.val().birthDate.toString() === value) {
            patients[childSnap.key] = childSnap.val()
          }
        })
        if (Object.keys(patients).length === 0) {
          this.setState({
            currentDoctorPatients: null
          })
        } else {
          this.setState({
            currentDoctorPatients: patients
          })
        }
      })
    }
  }

  getAllPatients () {
    const rootRef = dataAppDatabase.ref()
    const patientsRef = rootRef.child('riso').child('patientsByCountry').child(this.state.locale)
    let currentDoctorPatients = null
    patientsRef.on('value', snapshot => {
      currentDoctorPatients = snapshot.val()
      if (currentDoctorPatients !== null) {
        this.setState({
          currentDoctorPatients: currentDoctorPatients
        })
      }
    })
  }

  getPatients () {
    const rootRef = dataAppDatabase.ref()
    const patientsRef = rootRef.child('riso').child('patientsByCountry').child(this.state.locale)
    let currentDoctorPatients = null
    patientsRef.on('value', snapshot => {
      currentDoctorPatients = snapshot.val()
      if (currentDoctorPatients !== null) {
        this.setState({
          currentDoctorPatients: currentDoctorPatients
        })
      }
    })
  }

  handleChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleDateChange (date) {
    this.setState({
      search: date
    })
  }

  render () {
    return <div>
      <div className='panel'>
        <div className='form-horizontal'>
          <div>
            <label className='col-sm-3 control-label'>{polyglot.t('patientPicker.birthDate')}</label>
            <div className='col-sm-9 date-picker-input no-side-padding'>
              {isDateInputAvailable()
                  ? <input
                    type='date'
                    name='search'
                    onChange={(e) => this.handleChange(e)}
                    required
                    className='form-control margin-horizontal-input padding-input col-xs-12'
                    value={this.state.search && moment(this.state.search).format('L')}
                    placeholder={polyglot.t('patientPicker.birthDate')} />
                    : <DatePicker className='form-control' name='search' selected={this.state.search} onChange={this.handleDateChange} />
                }
            </div>
          </div>
          <button className='btn btn-default btn-block padding-input' onClick={this.searchPatientByBirthday}>{polyglot.t('patientPicker.search')}</button>
          <button className='btn btn-default btn-block padding-input' onClick={this.getAllPatients}>{polyglot.t('patientPicker.clearSearch')}</button>
        </div>
      </div>
      <div className='table-responsive'>
        <table className='table table-stripped table-bordered table-hover table-patients'>
          <thead>
            <tr>
              <th>{polyglot.t('patientPicker.number')}</th>
              <th>{polyglot.t('patientPicker.name')}</th>
              <th>{polyglot.t('patientPicker.birthDate')}</th>
            </tr>
          </thead>
          <tbody>
            {this.state.currentDoctorPatients
            ? Object.keys(this.state.currentDoctorPatients).map(function (key) {
              return <tr key={key}>
                <td><Link to={`/patients/${this.state.currentDoctorPatients[key].patientNumber}`}>{this.state.currentDoctorPatients[key].patientNumber}</Link></td>
                <td><Link to={`/patients/${this.state.currentDoctorPatients[key].patientNumber}`}>{this.state.currentDoctorPatients[key].name}</Link></td>
                <td><Link to={`/patients/${this.state.currentDoctorPatients[key].patientNumber}`}>{moment(this.state.currentDoctorPatients[key].birthDate).format('LL')}</Link></td>
              </tr>
            }.bind(this))
            : <tr><td colSpan='3' >{polyglot.t('patientPicker.loadingPatients')}</td></tr>
          }
          </tbody>
        </table>
      </div>
    </div>
  }
}

function PatientNumberForm (props) {
  return <div>
    <div className={props.alert} role='alert'>{polyglot.t('patientPicker.noPatientsWithNumber')}</div>
    <form name='user-info' id='login-form' onSubmit={props.handleSubmit}>
      <div className='form-group'>
        <label htmlFor='idNumber'>{polyglot.t('patientPicker.patientNumber')}</label>
        <input type='text' name='patientId' className='form-control' placeholder={polyglot.t('patientPicker.patientNumber')}
          value={props.patientId} onChange={(e) => props.handleChange(e)} />
      </div>
      <button type='submit' className='btn btn-personalized btn-large btn-block'>{polyglot.t('commonFields.enter')}</button>
    </form>
  </div>
}

PatientNumberForm.propTypes = {
  alert: PropTypes.string.isRequired,
  patientId: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/PatientPicker/PatientPicker.js